import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {OauthMeResponse} from '../../model';
import {ApiRequestOptions, CommerceApiService} from './commerce-api.service';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserApiService extends CommerceApiService {
  readonly controllerPath = 'oauth';

  constructor(
    protected http: HttpClient,
    protected store: Store,
  ) {
    super(http, store);
  }

  getCurrentUser(): Observable<OauthMeResponse> {
    return this.GET<OauthMeResponse>(this.getUrl('/me'), this.getOptions());
  }

  override getUrl(path = ''): string {
    return super.getUrl(`${this.controllerPath}${path}`);
  }

  protected override getOptions(
    src?: Partial<ApiRequestOptions>,
  ): ApiRequestOptions {
    const options = super.getOptions(src);

    if (!this.seApiToken()) {
      options.withCredentials = true;
    }

    return options;
  }
}
